import React, { FC, useState } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { FormItemInjectedProps } from '~/types/FormItemInjectedProps';
import { KsaShareholders } from '~/types/ksa/KsaShareholders';
import { Space } from '~/components';
import BeneficialOwnerAdd from '~/pages/ksa/application/shareholders/components/beneficialOwners/BeneficialOwnerAdd';
import BeneficialOwnerEdit from '~/pages/ksa/application/shareholders/components/beneficialOwners/BeneficialOwnerEdit';
import BeneficialOwnerTable, {
  getBeneficialOwnerData,
} from '~/pages/ksa/application/shareholders/components/beneficialOwners/BeneficialOwnerTable';

const MIN_SHARE_PERCENT_TO_ADD_BENEFICIARY_OWNER = 10;

const BeneficialOwnerTableForm: FC<Partial<FormItemInjectedProps<KsaShareholders>>> = (props) => {
  const { value, onChange } = props as FormItemInjectedProps<KsaShareholders>;
  const shareholdersFormState = { shareholders: value };

  const { t } = useTranslation('ksaApplication');

  const [editId, setId] = useState('');
  const openEdit = (uid: string) => {
    setId(uid);
  };
  const closeEdit = () => {
    setId('');
  };

  const beneficialOwnersDataSource = getBeneficialOwnerData(
    shareholdersFormState,
    openEdit,
    onChange
  );

  const legalEntities = shareholdersFormState.shareholders?.legalEntities;
  const showBeneficialOwnerAdd = !!legalEntities?.filter(
    (item) =>
      item?.ownershipShare?.percent &&
      item?.ownershipShare?.percent > MIN_SHARE_PERCENT_TO_ADD_BENEFICIARY_OWNER
  );

  return (
    <>
      {editId && <BeneficialOwnerEdit uid={editId} onClose={closeEdit} {...props} />}
      <Typography.Title level={4}>{t('Beneficial owners').toUpperCase()}</Typography.Title>
      <Typography.Paragraph>
        {t(
          'Because shares are held by a Legal entity as disclosed in the above section, please provide the details of Beneficial owners of the entity.'
        )}
      </Typography.Paragraph>
      <Space size={24} direction="vertical">
        <BeneficialOwnerTable beneficialOwners={beneficialOwnersDataSource} />
        {showBeneficialOwnerAdd && <BeneficialOwnerAdd {...props} />}
      </Space>
    </>
  );
};

export default BeneficialOwnerTableForm;
